import Box from "@mui/material/Box"
import { Outlet } from "react-router-dom"

const AuthLayout = () => {
  return (
    <Box display='flex' flexDirection='column' height='100%'>
      <Outlet />
    </Box>
  )
}

export default AuthLayout
